import en from './strings.en';

const ru = {
    selectAll: 'Выбрать все',
    canSelectAndInvite: 'Теперь можно выбрать всех перевозчиков и пригласить их на свою площадку или добавить в список',
};

export default { ru, en: { ...ru, ...en} };
